import React from "react";

export default function DutiesSS(props) {
  return (
    <div>
      <h1 className="text-3xl font-bold mb-6 text-yellow-500">
        Duties of Slum Soccer Management{" "}
      </h1>

      <div className="space-y-5">
        <div className="rounded-xl p-6 bg-white border border-gray-200 shadow-sm">
          <span className="text-gray-700 block mb-4">
            Slum Soccer Management, headed by CEO,SS shall :
          </span>
          <ul className="space-y-4 mb-4">
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Provide a safe working environment at the workplace which shall
                include safety from the persons coming into contact with women
                at the workplace.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Display the Policy on Slum Soccer(SS) website.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Conduct workshops and awareness programmes at regular intervals
                for sensitising the employees with the provisions of the Act
                and/or Policy as well as orientation programmes for the members
                of the ICC. It is mandated that employees should attend these
                awareness programmes/ training sessions.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                SS shall ensure that its management, employees and associates
                remain attentive and responsive to the issue of sexual
                harassment at the workplace; and, that all other persons who are
                granted access to SS’s workplace are made aware of this Policy.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Provide necessary facilities to the ICC/ Inquiry Committee for
                dealing with the complaint and conducting an inquiry.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Provide assistance to the complainant employee or associate if
                she chooses to file a complaint in relation to the offence under
                IPC or any other law in force.
              </span>
            </li>
            <li className="flex items-start">
              <span className="text-yellow-500 mr-2 ">•</span>
              <span className="text-gray-700">
                Treat sexual misconduct as misconduct under the service rules
                and initiate action for such misconduct.
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}
